import {
  FiHome,
  FiBookOpen,
  FiFileText,
  FiAward,
  FiCalendar,
  FiClock,
  FiUsers,
  FiSettings,
  FiBarChart,
  FiCheckSquare,
  FiDollarSign,
  FiTag,
  FiPackage,
  FiShoppingBag,
  FiCreditCard,
  FiEdit3,
  FiBook,
  FiHeart,
  FiTrash2,
  FiDownload
} from 'react-icons/fi';

/* Student-only navigation structure — grouped into purposeful sections so the
   sidebar reads more like a campus dashboard than a long flat list. The role
   check in the render still gates individual items, but everything below is
   already student-relevant so each item is implicitly studentOnly. */
export const studentNavigationItems = [
  {
    section: 'Home',
    items: [
      { path: '/dashboard', label: 'Dashboard', icon: FiHome },
    ],
  },
  {
    section: 'Academics',
    items: [
      { path: '/courses',          label: 'My Courses',           icon: FiBookOpen },
      { path: '/assignments',      label: 'My Assignments',       icon: FiFileText },
      { path: '/student/quizzes',  label: 'My Quizzes & Exams',   icon: FiEdit3 },
      { path: '/extensions/new',   label: 'My Extension Requests', icon: FiClock },
      { path: '/electives',        label: 'My Electives',         icon: FiBookOpen },
      { path: '/catalog',          label: 'Course Registration',  icon: FiBookOpen },
    ],
  },
  {
    section: 'Progress & Performance',
    items: [
      { path: '/grades',     label: 'My Grades',     icon: FiAward },
      { path: '/attendance', label: 'My Attendance', icon: FiCheckSquare },
    ],
  },
  {
    section: 'Learning Resources',
    items: [
      { path: '/student/notes',      label: 'My Notes',  icon: FiBook },
      { path: '/student/group-poll', label: 'Group Poll', icon: FiBarChart },
    ],
  },
  {
    section: 'Schedule',
    items: [
      { path: '/calendar', label: 'Calendar', icon: FiCalendar },
    ],
  },
  {
    section: 'Billing & Support',
    items: [
      { path: '/payment-history', label: 'Payment History', icon: FiCreditCard },
      { path: '/donation',        label: 'Make a Donation', icon: FiHeart },
    ],
  },
  {
    section: 'Account',
    items: [
      { path: '/settings', label: 'Settings', icon: FiSettings },
    ],
  },
];

export const navigationItems = [
  {
    section: 'Main',
    items: [
      { path: '/dashboard', label: 'Dashboard', icon: FiHome },
      { path: '/catalog', label: 'Course Registration', icon: FiBookOpen, studentOnly: true },
      { path: '/courses', label: 'My Courses', icon: FiBookOpen },
      { path: '/assignments', label: 'My Assignments', icon: FiFileText, studentOnly: true },
      { path: '/attendance', label: 'My Attendance', icon: FiCheckSquare, studentOnly: true },
      { path: '/student/quizzes', label: 'My Quizzes & Exams', icon: FiEdit3, studentOnly: true },
      { path: '/extensions/new', label: 'Request Extension', icon: FiClock, studentOnly: true },
      { path: '/grades', label: 'My Grades', icon: FiAward, studentOnly: true },
      { path: '/student/notes', label: 'My Notes', icon: FiBook, studentOnly: true },
      { path: '/electives', label: 'My Electives', icon: FiBookOpen, studentOnly: true },
      { path: '/assignments', label: 'Assignments', icon: FiFileText, instructorOnly: true },
      { path: '/student/group-poll', label: 'Group Poll', icon: FiBarChart, studentOnly: true },
      { path: '/instructor/quizzes', label: 'Quizzes', icon: FiEdit3, instructorOnly: true },
      { path: '/instructor/gradebook', label: 'Gradebook', icon: FiAward, instructorOnly: true },
      { path: '/calendar', label: 'Calendar', icon: FiCalendar },
      { path: '/payment-history', label: 'Payment History', icon: FiCreditCard, studentOnly: true },
      { path: '/donation', label: 'Make a Donation', icon: FiHeart },
      { path: '/settings', label: 'Settings', icon: FiSettings }
    ]
  },
  {
    section: 'Community',
    items: [
      { path: '/students', label: 'Students', icon: FiUsers }
    ]
  },
  {
    section: 'Administration',
    items: [
      // Admin Dashboard link removed — admins land on it via the "Dashboard"
      // entry under Main (which routes to AdminDashboard for admin role).
      { path: '/admin/users', label: 'User Management', icon: FiUsers, adminOnly: true },
      { path: '/admin/extensions', label: 'Extension Requests', icon: FiCalendar, instructorOnly: true },
      { path: '/admin/courses', label: 'Course Management', icon: FiBookOpen, instructorOnly: true },
      { path: '/admin/electives', label: 'Elective Management', icon: FiBookOpen, instructorOnly: true },
      { path: '/admin/attendance', label: 'Attendance Management', icon: FiCheckSquare, instructorOnly: true },
      { path: '/admin/deleted-items', label: 'Recently Deleted', icon: FiTrash2, adminOnly: true },
      { path: '/admin/import-export', label: 'Import/Export', icon: FiDownload, adminOnly: true },
      { path: '/instructor/polls', label: 'Poll Manager', icon: FiBarChart, instructorOnly: true },
      { path: '/instructor/live-poll', label: 'Live Poll Board', icon: FiBarChart, instructorOnly: true },
      { path: '/admin/pricing', label: 'Course Pricing', icon: FiDollarSign, adminOnly: true },
      { path: '/admin/promo-codes', label: 'Promo Codes', icon: FiTag, adminOnly: true },
      { path: '/admin/bulk-pricing', label: 'Bulk Pricing', icon: FiPackage, adminOnly: true },
      { path: '/admin/additional-products', label: 'Additional Products', icon: FiShoppingBag, adminOnly: true },
      { path: '/admin/purchase-lookup', label: 'Purchase Lookup', icon: FiCreditCard, adminOnly: true },
      { path: '/admin/reports', label: 'Enrollment Reports', icon: FiBarChart, adminOnly: true }
    ]
  }
];
